import React, { useCallback, useEffect, useState } from 'react';
import { checkEmbryos, EmbroCheckData, getPatientHistoryResultList, mapPatientHistoryResults } from '../../EmbryoGradingAI/EmbryoGradingAi.helper';
import { usePatientContext } from '../../../components/SubPatinetProvider';
import SinglePatientGradingModal from '../../EmbryoGradingAI/SinglePatientGradingModal/SinglePatientGradingModal';
import { useAlert } from '../../../components/alertProvider';
import { useTranslation } from 'react-i18next';
import { useGradingHistory } from '../../EmbryoGradingAI/GradingHistoryContext';
import HeaderProfile from '../../../components/header_Profile/header_Profile.index';
import { PatientData } from '../PatientListHelper';
import CyclePicker from '../../../components/Embryology/cyclePicker';
import { CycleData } from '../../../components/Surgery/oocyteRetrieval/OocyteRetrival.helper';

const AimbryoDetails: React.FC = () => {
  const [gradingModalOpen, setGradingModalOpen] = useState(false);
  const { patientId } = usePatientContext();
  const { addAlert } = useAlert();
  const { setResultListForSelectedPatient, setSelectedResultFromResultList, setSelectedPatientForGrading, setShowFullResult } = useGradingHistory();
  //   const { t: tCulture } = useTranslation('culture_config'); 
  const { t: tAiGrading } = useTranslation('aiGrading_config');
  // eslint-disable-next-line 
  const [selectedPatient, setSelectedPatient] = useState<PatientData | null>(null);
  // eslint-disable-next-line 
  const [selectedCycle, setSelectedCycle] = useState<CycleData | null>(null);
  // eslint-disable-next-line 
  const [cyclesAvailable, setCyclesAvailable] = useState(false);
  const [embryosData, setEmbryosData] = useState<EmbroCheckData | null>(null);
  
  useEffect(() => {
    setShowFullResult(false);  // reset to false when open modal
    setGradingModalOpen(true);

    // Use helper to map and set patient/result data
    getPatientHistoryResultList({ patient_id: patientId })
      .then((response) => {
        if (response && Array.isArray(response)) {
          setGradingModalOpen(true);
          mapPatientHistoryResults(
            response,
            setSelectedPatientForGrading,
            setResultListForSelectedPatient,
            setSelectedResultFromResultList,
          );
        }
        else {
          addAlert(tAiGrading('failedToLoadGradingHistory'), 'error');
        }
      })
      .catch(() => {
        addAlert(tAiGrading('failedToLoadGradingHistory'), 'error');
        setGradingModalOpen(false);  //close modal
      });

    // Call checkEmbryos API and store response
    const fetchEmbryos = async () => {
      if (patientId) {
        try {
          const response = await checkEmbryos(patientId);
          setEmbryosData(response);
        } catch {
          addAlert('Failed to fetch embryos data', 'error');
        }
      }
    };
    fetchEmbryos();
  // eslint-disable-next-line 
  }, [patientId]);
  const handleDataFromHeader = (data: PatientData) => {
    setSelectedPatient(data);
  };
  
  const handleCycleChange = useCallback(
    (selectedCycle: CycleData | null) => {
      if (selectedCycle) {
        setSelectedCycle(selectedCycle);
      } else {
        // eslint-disable-next-line no-console
        console.log('No cycle selected');
      }
    },
    [] 
  );
  return (
    <>
      <div>
        <HeaderProfile onData={handleDataFromHeader} />
      </div>    
      <div style={{margin:'20px 15px'}}>
        <CyclePicker onCycleChange={handleCycleChange} onCycleAvailabilityChange={setCyclesAvailable} />

      </div>
      {/* Add your component content here */}
      {
        gradingModalOpen && embryosData?.has_day5_embryos === true && <SinglePatientGradingModal
          IsFromAimbryoDetails={true}
          onClose={() => setGradingModalOpen(false)}
          onSave={() => { }}
          initialValues={{
            aiViabilityScore: 0,
            grade: '',
            icmGrade: '',
            teGrade: '',
            embryoId: ''
          }}       
        />
      }
    </>
  );
};

export default AimbryoDetails;
